module.exports = __webpack_public_path__ + "img/6.ffc829a6.png";